export default "__VITE_ASSET__B2jiz6Fc__"